import PropTypes from 'prop-types';
import { useEffect, useState, useContext,  useMemo} from 'react'; // useMemo pour Table.jsx

import { DonneesUtilisateurContext } from '../../contexte.js';

import { hdleClickNoPossible } from '../../fonctionsDiv.js';
import { apiFormGetInfosDiv, apiFormAssocDissoCertif } from '../../Datas/dataFormations.js'
import { apiCertifAppelBase } from '../../Datas/dataDiplomes.js'

import LiensPrecedentSuivant from '../../Components/LiensPrecedentSuivant.jsx';
import LoadingSpinner from "../../Components/LoadingSpinner";
import RechercheCertif from '../../Components/RechercheCertif.jsx'
import MessageInfoBox, {MessageErreurApi} from '../../Components/Messages.jsx';
import Table from '../../Components/Table.jsx'
import {ButtonVoirFiche, ButtonSuppr } from '../../Components/ButtonsCustom.jsx';
import DetailCertif from '../../Components/DetailCertif.jsx'
import BlocsCompetencesForm from '../../Components/BlocsCompetencesForm.jsx';

/**
 * Return Formulaire étape 1c (pour formation partielle, ID_LHEO_TYPE_VALIDATION_BLOCS_FORM = 0)
 * on touve des conditionS ID_LHEO_TYPE_VALIDATION_BLOCS_FORM == 2 mais d'apèrès les dernières décisions le mixte va etre géré dans Etape1
 *
 * @component
 * @summary page étape 1
 * @param {  }
 * @return { HTMLElement }
*/
function FormEtape1c(props) {
    let numEtape = 1;

    const formationNumber = props.formationNumber; //const { formationNumber } = useParams() // aurait pu faire ceci et ainsi ne pas passer la var en props

    const { utilisateurBearer } = useContext(DonneesUtilisateurContext);
    const [dataApi, setDataApi] = useState();
    const [dataLoaded, setDataLoaded] = useState(true);
    const [messageProbleme, setMessageProbleme] = useState();

    const [msgInfoF, setMsgInfoF] = useState();

    const [dataLoadedDetailCi, setDataLoadedDetailCi] = useState(false);
    const [dataDetailCertif, SetDataDetailCertif] = useState();

    // pour gestion blocs :
    const [choixID_ACTIONS_FORMATION_BLOCS, setChoixID_ACTIONS_FORMATION_BLOCS] = useState();
    const [choixCode_rncp, setChoixCode_rncp] = useState();

    //pour react-table https://stackoverflow.com/questions/56922381/how-to-include-url-in-react-table-cell
    const columns = useMemo(
        () => [
          {
            id:'listesDiplomes',
            hideHeader : false,
            trieDefautRp : 'intitule_diplome',
            columns: [
                { 
                  Header: () => <>Code Certif<br />info</>,
                  accessor: 'code_diplome',
                },
                {  
                  Header: 'Libellé', 
                  accessor: 'intitule_diplome', 
                  id: "intitule_diplome",
                  Cell: ({ row }) => (       
                    <a title="Voir la fiche" className="lib" onClick={() => handleClickViewCerifBootStrap(row.original.code_diplome)}>
                          {row.original.intitule_diplome}&nbsp;
                    </a>
                  ),
                },
                { 
                  Header: () => <>Code<br />RNCP</>,
                  accessor: 'code_rncp',
                },
                { 
                  Header: 'Nom du ou des certificateur(s)', 
                  accessor: 'certificateur_lib',
                  disableSortBy: true,
                },
                { 
                  Header: 'Etat', 
                  id: "etat_lib_center",
                  accessor: 'etat_lib',
                },
                {
                  Header: () => <>Principale</>,
                    accessor: 'PRINCIPAL', 
                    id: "PRINCIPAL_center",
                    disableSortBy: true,
                    Cell: ({ row }) => (
                        <>
                          {row.original.PRINCIPAL == true &&
                            <span className="enrobage-boutton"><span className="fas fa-star"></span></span>
                          }
                        </>
                    ),
                },
                {
                  Header: () => <></>,
                    accessor: 'actions', 
                    id: "asso_center",
                    disableSortBy: true,
                    Cell: ({ row }) => (
                        <>
                          <a title="Voir la fiche" onClick={() => handleClickViewCerifBootStrap(row.original.code_diplome)}>
                            <ButtonVoirFiche />
                          </a>
                          {props.infosGenFormation["nbActions"] == 0 &&
                            props.infosProprietes["ACTIONS_CERTIFICATIONS|other_dataEditable"].editable == 1 ?
                            <a title="Dissocier" onClick={() => handleClickDissoCerif(row.original.code_diplome)}>
                              <ButtonSuppr />
                            </a>
                            :
                            <a title="Suppression impossible, cliquez pour en savoir plus" 
                              onClick={() => hdleClickNoPossible()}>
                            <ButtonSuppr disabled="disabled"  />
                            </a>
                          }
                        </>
                    ),
                },
            ]
          },
        ],
        []
    )

    const handleClickAssoCerif = async (codeDiplomeAasso, codeEtat) => {
        SetDataDetailCertif();
        setDataLoaded(false);
        setMessageProbleme();
        var dataR = await apiFormAssocDissoCertif(utilisateurBearer, formationNumber, codeDiplomeAasso, 'PUT');

        switch (dataR.statusCode) {
            case 200:
                await recupCertifsDeLaformation(); // reload la liste (cette fct va provoquer l'affichage du composant BlocsCompetencesForm grace à setChoixID_ACTIONS_FORMATION_BLOCS et setChoixCode_rncp)
                var messageAafficher = dataR.dataApi;
                if(messageAafficher.includes("a bien été associée"))  {
                  messageAafficher +=" \r\nMaintenant que vous avez sélectionné la certification, veuillez sélectionner un ou plusieurs blocs.";
                }
                alert(messageAafficher);
              break;
            case 401:
                setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
              break;
            case 400:
                setMessageProbleme(dataR.dataApi); // un message personnalisé est retourné dans ce cas, ex : "La fiche certif info est déjà associée"
              break;
            default:
                setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
        }
        setDataLoaded(true);
    }

    const handleClickDissoCerif  = async (codeDiplomeAasso) => {
        SetDataDetailCertif();
        setDataLoaded(false);
        setMessageProbleme();
        var dataR = await apiFormAssocDissoCertif(utilisateurBearer, formationNumber, codeDiplomeAasso, 'DELETE');

        switch (dataR.statusCode) {
            case 200:
              await recupCertifsDeLaformation(); // reload la liste des certifs
                if(dataR.dataApi != "") alert(dataR.dataApi);
                else {
                  alert("La dissociation a bien été effectuée");
                  objaAmodif.etape1 = "nok";
                }
              break;
            case 401:
                setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
              break;
            default:
                setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
        }

        setChoixID_ACTIONS_FORMATION_BLOCS(null);
        setDataLoaded(true);
    }

    const handleClickViewCerifBootStrap  = async (codeDiplomeAasso) => {
      setDataLoadedDetailCi(false);
      var dataR = await apiCertifAppelBase(utilisateurBearer, codeDiplomeAasso);
      if(global.config.modeDebugApp == 1) console.log('retour apiCertifAppelBase : ', dataR);
      switch (dataR.statusCode) {
          case 200:
              SetDataDetailCertif(dataR.dataApi);
            break;
          case 401:
              setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
            break;
          default:
              setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
      }
      setDataLoadedDetailCi(true);     
    }
    
    const [notifSuivant, setNotifSuivant] = useState();
    async function recupCertifsDeLaformation() {
        SetDataDetailCertif();
        const dataR = await apiFormGetInfosDiv(utilisateurBearer, formationNumber, "/certifications");
        if(global.config.modeDebugApp == 1) console.log('retour apiFormGetInfosDiv : ', dataR);

        switch (dataR.statusCode) {
          case 200:
              setDataApi(dataR.dataApi);
              var nbCertifAssociees = dataR.dataApi.length;
              var objaAmodif = JSON.parse(JSON.stringify(props.infosGenFormation)); // on clone (duplique) l'objet pour que tout fonctionne bien
              objaAmodif.nbCertifications = nbCertifAssociees;
              //objaAmodif.etape1 = nbCertifAssociees > 0 ? "ok" : "nok"; // permet notamment d'afficher le lien "suivant"
              //nbCertifAssociees > 0 ? setNotifSuivant("J'ai terminé ma sélection et<br />je passe à l'étape suivante") : setNotifSuivant();
              props.SetInfosGenFormation(objaAmodif);

              if(props.infosGenFormation["nbActions"] == 0) {
                var messageInfoBase = `Vous débutez la déclaration d'une formation préparant à `
                if(props.infosGenFormation.ID_LHEO_TYPE_VALIDATION_BLOCS_FORM ==  0) {
                  messageInfoBase += `la validation <u>partielle d'une seule certification (un ou plusieurs blocs de compétences)</u>`
                }
                else if(props.infosGenFormation.ID_LHEO_TYPE_VALIDATION_BLOCS_FORM == 2) {
                  messageInfoBase += `la validation <u>totale</u> d'une certification <u>avec possibilité de parcours individualisés</u> sur tous ou certains de ses blocs de compétences</u>`
                }
                messageInfoBase += `.<br /><br />Le menu de gauche représente les diverses étapes et vous permettra ensuite de naviguer entre elles.<br /> 
                Le renseignement correct d'une étape vous permet de passer à la suivante, jusqu’à la déclaration des sessions.`;

                setMsgInfoF(messageInfoBase); 
              }
              else {
                var messageInfoBase = `Cette formation prépare à `
                if(props.infosGenFormation.ID_LHEO_TYPE_VALIDATION_BLOCS_FORM ==  0) {
                  messageInfoBase += `la validation partielle d'une seule certification (un ou plusieurs blocs de compétences)`
                }
                else if(props.infosGenFormation.ID_LHEO_TYPE_VALIDATION_BLOCS_FORM == 2) {
                  messageInfoBase += `la validation d'une certification en totalité et aussi de certains de ses blocs`
                }
                messageInfoBase += `.<br /><br />Vous ne pouvez pas modifier la certification associée à une formation ni les blocs que vous avez sélectionné si des actions sont déjà déclarées.`

                setMsgInfoF(messageInfoBase); 
              }

              if(nbCertifAssociees > 0) {
                setChoixID_ACTIONS_FORMATION_BLOCS(dataR.dataApi[0].ID_ACTIONS_FORMATION_BLOCS);
                setChoixCode_rncp(dataR.dataApi[0].code_rncp);
              }
            break;
          case 401:
              setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
            break;
          default:
              setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
      }
   }

   const [nbBlocEnregistres, setnbBlocEnregistres] = useState();
   useEffect(() => {
      if(global.config.modeDebugApp == 1) console.log('useffect nbBlocEnregistres : ', nbBlocEnregistres);

      var objaAmodif = JSON.parse(JSON.stringify(props.infosGenFormation)); // on clone (duplique) l'objet pour que tout fonctionne bien              
      if(nbBlocEnregistres > 0 && objaAmodif.nbCertifications > 0) {
        setMessageProbleme(null);        
        objaAmodif.etape1 = "ok"; // premet notamment d'afficher le lien "suivant"
        setNotifSuivant("J'ai terminé ma sélection et<br />je passe à l'étape suivante")        
      }
      if(nbBlocEnregistres == 0) {
        objaAmodif.etape1 = "nok";
        //setNotifSuivant("Veuillez enregistrer vos modifications") //uselesse à cause de objaAmodif.etape1 = "nok"; dont le message prend le dessus
      }
      props.SetInfosGenFormation(objaAmodif);
   }, [nbBlocEnregistres]);

   async function chargementsConsecutifs() {
    setDataLoaded(false);
    await recupCertifsDeLaformation();
    setDataLoaded(true);
  }

   useEffect(() => {
    if(global.config.modeDebugApp == 1)  console.log('useffect FormEtape1c, props.infosGenFormation : ', props.infosGenFormation)
    document.title = `Edition de la formation ${formationNumber}`;
    chargementsConsecutifs();
   }, []);
   

    return (
        <>
          {global.config.modeDebugApp == 1 && <div className="debug">nbBlocEnregistres : {nbBlocEnregistres}</div>}

          <LoadingSpinner dataLoaded={dataLoaded} />
          <MessageInfoBox message={msgInfoF} />
          <MessageInfoBox message={props.infosProprietes["ACTIONS_FORMATION|other_dataEditable"].aide} />
          <MessageErreurApi message={messageProbleme} />

          {dataLoaded && dataApi &&
          <>
            {props.infosGenFormation["nbActions"] == 0 && props.infosProprietes["ACTIONS_CERTIFICATIONS|other_dataEditable"].editable == 1 && 
            dataApi.length == 0 &&
              <RechercheCertif handleClickAssoCerif={handleClickAssoCerif} handleClickViewCerifBootStrap={handleClickViewCerifBootStrap} 
              infosGenFormation={props.infosGenFormation} restrictionRecherche="RncpOnly" />
            }

            <section className="certifications-associees">
                {dataApi.length > 0 ?
                <>
                  <div className="titre">
                  {dataApi.length > 1 ? 
                    <>{dataApi.length} certifications sont actuellement associées à votre formation - cliquez sur la <span className="fas fa-magnifying-glass picto-legende"></span> pour visualiser le détail de l'une d'elles (romes, nsf...)</>
                    :
                    <>Une certification est actuellement associée à votre formation - cliquez sur la <span className="fas fa-magnifying-glass picto-legende"></span> pour la visualiser en détail (romes, nsf...)</>
                  } 
                  </div> 


                  <Table columns={columns} data={dataApi} noPagination={true} noDisplayNbResult={true} noFilter={true} />
                </>
                :
                <div className="titre">Aucune fiche certif info n'est associée à cette formation.</div>
                }
            </section>          

            {dataLoadedDetailCi && dataDetailCertif != null &&
            <>
            <DetailCertif dataDetailCertif={dataDetailCertif} isPro={false}/>
            </>}

            {choixID_ACTIONS_FORMATION_BLOCS && <BlocsCompetencesForm ID_ACTIONS_FORMATION_BLOCS={choixID_ACTIONS_FORMATION_BLOCS}
                                                                      code_rncp={choixCode_rncp}
                                                                      setnbBlocEnregistres={setnbBlocEnregistres} 
                                                                      infosGenFormation={props.infosGenFormation} />}

            <LiensPrecedentSuivant  formationNumber={formationNumber} numEtape={numEtape} infosGenFormation={props.infosGenFormation} notifBeCareful={false}
                                    notifSuivant={notifSuivant} />
          </>
          }
        </>
    )

}

FormEtape1c.propTypes = {
  formationNumber: PropTypes.number.isRequired,
  SetInfosGenFormation : PropTypes.func,
  infosGenFormation: PropTypes.object,
}

export default FormEtape1c;